// extracted by mini-css-extract-plugin
export default {"table-header":"header_table-header__b0P4W"};